import React, { Fragment, useState, useEffect, Component } from "react";
import { connect } from "react-redux";
import { Link, Route, Router, Switch } from "react-router-dom";
import { Pagination, Responsive } from "semantic-ui-react";

import AdminWrapper from "../AdminWrapper";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// import SwipeableViews from 'react-swipeable-views';

import { API } from "../../../API";
import {
	getTotalPages,
	extractDataOfCurrPage,
} from "../../../Helper/PagingHelper";
import { populateCollegeData } from "../../../Helper/CollegeHelper";
import { updateCurrentCollegeDetails } from "../../../redux/admin/admin.actions";
import { compose } from "redux";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import { notify } from "react-notify-toast";
import { handleCollegeMultiDateBookings } from "../../Bookings2/Helper";

// Define constant values
const ROW_PER_PAGE = 10;

const AllArchivedColleges = ({ history, updateCurrentCollegeDetails, props }) => {
	const [allCustomers, setAllCustomers] = useState([]);
	const [allInsts, setAllInsts] = useState([])
	const [user, setUser] = useState() //Shared user
	const [pageNum, setPageNum] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [filteredCustomers, setFilteredCustomers] = useState([]);
	const [customersOfCurrPage, setCustomersOfCurrPage] = useState([]);
	const [selectedTab, setSelectedTab] = useState(0)

	useEffect(() => {
		getAllArchivedColleges();
	}, []);

	const dateFromObjectId = (objectId) => {
		return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
	};

	const getAllArchivedColleges = () => {
		API.allArchivedCollegs()
			.then((result) => {
				console.log("result: ", result?.data)
				const { customers, institutions } = result?.data
				setAllCustomers(customers)
				setAllInsts(institutions)
			})
			.catch((err) => {
				console.log(err.response);
			});
	};

	const getContactName = (first_name, last_name) => {
		let result = "";

		if (first_name) {
			result += first_name + " ";
		}

		if (last_name) {
			result += last_name;
		}

		return result;
	};

	const buildTableHeader = (headerName) => {
		return <th className="availability-table-head-cell">{headerName}</th>;
	};

	const bindTableData = (data) => {
		return <td className="availability-table-cell">{data}</td>;
	};

	const bindTableDataWithId = (value, id, data) => {
		return (
			<td value={value} id={id} className="availability-table-cell">
				{data}
			</td>
		);
	};

	const buildProfileLocation = (customer) => {
		let location = null;

		if (customer.institution) {
			location = {
				pathname: `/NavigateToCollegeSharedProfile?id=${customer.institution_id}`,
			};
		}
		return location;
	};

	const bindProfileLink = (customer) => {
		const location = buildProfileLocation(customer);
		return (
			<td className="availability-table-cell">
				{location && (
					<Link
						className="mdi mdi-account-circle-outline home-icon-margin-adjust profile-link"
						to={location}
						target="_blank"
					></Link>
				)}
			</td>
		);
	};

	const onDetailsClicked = async (customer) => {
		const user = { ...customer };
		user.role = "customer";

		const college = await populateCollegeData(customer.institution);
		college.user = user;

		updateCurrentCollegeDetails(college);
		history.push("/CollegeDetails");
	};

	const onHyperLinkClicked = async (customer) => {
		const user = { ...customer };
		user.role = "customer";

		const college = await populateCollegeData(customer.institution);
		college.user = user;

		updateCurrentCollegeDetails(college);
		history.push("/CollegeDetailCalendar");
	};

	const bindCalendarLink = (customer) => {
		return (
			<td className="availability-table-cell">
				{customer.institution && (
					<Link
						className="mdi mdi-timetable home-icon-margin-adjust profile-link"
						title="Nav Inst Calendar"
						onClick={() => onHyperLinkClicked(customer)}
					>
					</Link>
				)}
			</td>
		)
	}

	const bindMoreDetailsLink = (customer) => {
		return (
			<td className="availability-table-cell">
				{customer.institution && (
					<Link
						className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
						onClick={(event) => onDetailsClicked(customer)}
					>
						More Details
					</Link>
				)}
			</td>
		);
	};

	const bindInstLogo = (logo) => {
		return (
			<td className="availability-table-cell">
				<img src={logo} width={50} />
			</td>
		)
	}

	const handleChange = (event, value) => {
		console.log("valueee: ", value)
		setSelectedTab(value)
	};

	return (
		<AdminWrapper>
			<Fragment>
				<SwitchMenuBar isViewAsTeacher />
				<div className="page-container-main bg-photoregister">
					<div className="bg-gradient page-container-bg"></div>
					<div className="page-container-header">
						<div className="page-container-header-inner">
							<div className="d-flex flex-row align-items-center">
								<div className="p-2">
									<h1>Manage Archived Colleges</h1>
								</div>
								{/* <div className="p-2">
                  <SearchBar
                    placeholder="Search by Keyword"
                    onChange={searchByName}
                  />
                </div> */}
							</div>
						</div>
					</div>
					<div className="page-container-inner">
						<div className="availability-table-body">
							<div className="availability-table-body-content overflow-auto">
								<Tabs
									value={selectedTab}
									fullWidth
									onChange={(event, value) => handleChange(event, value)}
									variant="scrollable"
									TabIndicatorProps={{
										style: { background: "#34F1C8", color: "#34F1C8" }
									}}
									scrollButtons="on">
									<Tab label={<span>Customers</span>} />
									<Tab label={<span>Institutions</span>} />
								</Tabs>

								{selectedTab === 0 && (
									<div className="page-container-inner">
										<div className="availability-table-body">
											<div className="availability-table-body-content overflow-auto">
												<table className="av-tab-root">
													<thead className="availability-table-head">
														<tr className="availability-table-head-row">
															{buildTableHeader("Institution Name")}
															{buildTableHeader("Contact Name")}
															{buildTableHeader("Contact Email")}
															{buildTableHeader("Contact Number")}
															{buildTableHeader("Profile")}
															{/* {buildTableHeader("HyperLink")} */}
															{buildTableHeader("Details")}
														</tr>
													</thead>
													<tbody className="availability-table-body-bodytable">
														{allCustomers.map((customer, index) => (
															<tr key={index} className="availability-table-body-row">
																{bindTableData(customer.institution?.institution_name || customer.institution_name)}
																{bindTableDataWithId(
																	customer._id,
																	customer._id,
																	getContactName(
																		customer.first_name,
																		customer.last_name
																	)
																)}
																{bindTableData(customer.email)}
																{bindTableData(customer.mobile)}
																{bindProfileLink(customer)}
																{/* {bindCalendarLink(customer)} */}
																{bindMoreDetailsLink(customer)}
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								)}

								{selectedTab === 1 && (
									<div className="page-container-inner">
										<div className="availability-table-body">
											<div className="availability-table-body-content overflow-auto">
												<table className="av-tab-root">
													<thead className="availability-table-head">
														<tr className="availability-table-head-row">
															{buildTableHeader("Institution Logo")}
															{buildTableHeader("Institution Name")}
															{buildTableHeader("Institution Short Name")}
														</tr>
													</thead>
													<tbody className="availability-table-body-bodytable">
														{allInsts.map((inst, index) => (
															<tr key={index} className="availability-table-body-row">
																{bindInstLogo(inst.logo)}
																{bindTableData(inst.institution_name)}
																{bindTableData(inst.inst_shortname)}
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								)}

							</div>

							{/* <div className="row bookings-bottom pb-0">
                <div className="col-lg-3 col-md-0 "></div>
                <div className="col-lg-6  col-md-12 bookings-bottom-pagination">
                  <Responsive minWidth={1500}>
                    <Pagination
                      totalPages={totalPages}
                      siblingRange={1}
                      ellipsisItem={false}
                      firstItem={false}
                      lastItem={false}
                      onPageChange={(e) => onPageNumChange(e)}
                      activePage={pageNum}
                    />
                  </Responsive>
                  <Responsive minWidth={1200} maxWidth={1499}>
                    <Pagination
                      totalPages={totalPages}
                      ellipsisItem={false}
                      firstItem={false}
                      lastItem={false}
                      boundaryRange={0}
                      siblingRange={1}
                      onPageChange={(e) => onPageNumChange(e)}
                      activePage={pageNum}
                    />
                  </Responsive>
                  <Responsive maxWidth={1199}>
                    <Pagination
                      totalPages={totalPages}
                      ellipsisItem={false}
                      firstItem={false}
                      lastItem={false}
                      boundaryRange={0}
                      siblingRange={0}
                      onPageChange={(e) => onPageNumChange(e)}
                      activePage={pageNum}
                    />
                  </Responsive>
                </div>
              </div> */}
						</div>
					</div>
				</div>
			</Fragment>
		</AdminWrapper>
	);
};

const mapDispatchToProps = (dispatch) => ({
	updateCurrentCollegeDetails: (colleges) =>
		dispatch(updateCurrentCollegeDetails(colleges)),
});

export default connect(null, mapDispatchToProps)(AllArchivedColleges);
